import React from "react";
import Modal, { modalStyles as m } from "./Modal";
import { fmt } from "../uiUtils";

// Android lotteryAndScratcherPayoutDialog (DialogCustomItemBinding reused): the keyed amount, then
// "Lottery Payout" or "Scratcher Payout" — each adds a payout line to the cart for that amount.
export default function PayoutKindModal({ amount, onPick, onClose }) {
  return (
    <Modal title="Lottery" onClose={onClose}>
      <div style={m.label}>Payout amount</div>
      <div style={{ fontSize: 28, fontWeight: 800, letterSpacing: "-0.01em", margin: "4px 0 12px" }}>{fmt(amount)}</div>
      <button style={m.primary} onClick={() => onPick("lottery")}>Lottery Payout</button>
      <button style={{ ...m.primary, background: "#7C3AED" }} onClick={() => onPick("scratcher")}>Scratcher Payout</button>
      <button style={m.ghost} onClick={onClose}>Cancel</button>
    </Modal>
  );
}
